module.exports = __webpack_public_path__ + "static/media/Artboard18.b30b075f.png";